import React, { useState, useEffect } from "react";
import { formatSafeDate } from "../../../utils/textUtils";
import {
  Table,
  Button,
  Input,
  Form,
  Select,
  Flex,
  Avatar,
  Typography,
  Dropdown,
  Menu,
  Card,
  Tag,
  Tooltip,
  message,
  Modal,
} from "antd";
import axios from "axios";
import {
  MoreOutlined,
  SearchOutlined,
  ShoppingOutlined,
  SnippetsOutlined,
  WechatOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  FilePdfOutlined,
  DownloadOutlined,
  TeamOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { UserManagementWrapper, PageHeader, MetricsContainer, TabsContainer } from "./../UserManagement/UserManagement.style";
import { API_CONST } from "../../../const";
import { Link, useNavigate } from "react-router-dom";
import BulkUploadJobs from "../../../components/BulkUploadJobs/BulkUploadJobs";
const { Text, Title } = Typography;
const { Option } = Select;

const JobRequirments = () => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bulkUploadVisible, setBulkUploadVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("Active Jobs");
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // Indian state abbreviations
  const stateAbbreviations = {
    'Andhra Pradesh': 'AP', 'Arunachal Pradesh': 'AR', 'Assam': 'AS', 'Bihar': 'BR',
    'Chhattisgarh': 'CG', 'Goa': 'GA', 'Gujarat': 'GJ', 'Haryana': 'HR',
    'Himachal Pradesh': 'HP', 'Jharkhand': 'JH', 'Karnataka': 'KA', 'Kerala': 'KL',
    'Madhya Pradesh': 'MP', 'Maharashtra': 'MH', 'Manipur': 'MN', 'Meghalaya': 'ML',
    'Mizoram': 'MZ', 'Nagaland': 'NL', 'Odisha': 'OD', 'Punjab': 'PB',
    'Rajasthan': 'RJ', 'Sikkim': 'SK', 'Tamil Nadu': 'TN', 'Telangana': 'TS',
    'Tripura': 'TR', 'Uttar Pradesh': 'UP', 'Uttarakhand': 'UK', 'West Bengal': 'WB',
    'Delhi': 'DL', 'Jammu and Kashmir': 'JK', 'Ladakh': 'LA', 'Puducherry': 'PY',
    'Chandigarh': 'CH', 'Andaman and Nicobar Islands': 'AN', 'Dadra and Nagar Haveli': 'DN',
    'Daman and Diu': 'DD', 'Lakshadweep': 'LD',
  };

  const formatLocation = (location) => {
    if (!location) return '-';
    const parts = location.split(',').map(p => p.trim());
    if (parts.length >= 2) {
      const city = parts[0];
      const state = parts[1];
      const abbrev = stateAbbreviations[state] || state;
      return `${city}, ${abbrev}`;
    }
    return location;
  };

  // Active Jobs columns
  const activeJobsColumns = [
    { 
      title: "Job Id", 
      dataIndex: "id", 
      key: "id",
      width: 130,
      render: (id) => (
        <a
          onClick={() => navigate(`/admin/job-requirments/job-details/${id}`)}
          style={{ color: "#1890ff", cursor: "pointer", fontWeight: 500 }}
        >
          {id}
        </a>
      ),
    },
    { 
      title: "Customer Organization", 
      dataIndex: "customerOrganization", 
      key: "customerOrganization", 
      width: 180,
      render: (org) => org ? (
        <a
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() => navigate(`/admin/organization/${encodeURIComponent(org)}`, {
            state: { from: "/admin/job-requirments", fromLabel: "Back to Job Requirements" }
          })}
        >
          {org}
        </a>
      ) : "-",
    },
    { title: "Job Requirement Title", dataIndex: "role", key: "role", width: 180 },
    { title: "Location", dataIndex: "location", key: "location", width: 180, render: (loc) => formatLocation(loc) },
    { title: "Reporting Country", dataIndex: "reportingCountry", key: "reportingCountry", width: 150, render: (v) => v || "-" },
    { title: "Type", dataIndex: "engagement_type", key: "engagement_type", width: 140 },
    { title: "Positions", dataIndex: "requirement_count", key: "requirement_count", width: 100 },
    { title: "Experience", dataIndex: "experience", key: "experience", width: 120 },
    { title: "Duration", dataIndex: "engagement_months", key: "engagement_months", width: 120 },
    { title: "Start Date", dataIndex: "start_date", key: "start_date", width: 120 },
    { title: "Salary(INR)", dataIndex: "budget", key: "budget", width: 130 },
    { title: "Created On", dataIndex: "created_on", key: "created_on", width: 120 },
    { 
      title: "Status", 
      dataIndex: "status", 
      key: "status", 
      width: 130,
      render: (status) => {
        const statusColors = {
          'open': 'green',
          'draft': 'orange',
          'pending_approval': 'gold',
          'closed': 'red',
          'filled': 'blue',
        };
        const statusLabels = {
          'open': 'Active',
          'draft': 'Draft',
          'pending_approval': 'Pending Approval',
          'closed': 'Closed',
          'filled': 'Filled',
        };
        return <Tag color={statusColors[status] || 'default'}>{statusLabels[status] || status}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      fixed: "right",
      render: (_, record) => {
        const items = [
          {
            key: "edit",
            label: "Edit",
            onClick: () => navigate(`/admin/job-requirments/edit-job/${record.id}`),
          },
          {
            key: "view",
            label: "View Details",
            onClick: () => navigate(`/admin/job-requirments/job-full-details/${record.id}`),
          },
        ];

        if (record.status === 'open') {
          items.push({
            key: "close",
            label: "Close Job",
            onClick: () => handleUpdateStatus(record.id, 'closed'),
          });
          items.push({
            key: "fill",
            label: "Mark as Filled",
            onClick: () => handleUpdateStatus(record.id, 'filled'),
          });
        }

        items.push({
          key: "delete",
          label: "Delete",
          danger: true,
          onClick: () => handleDeleteJob(record.id),
        });

        return (
          <Dropdown menu={{ items }} trigger={["click"]}>
            <MoreOutlined style={{ cursor: "pointer" }} />
          </Dropdown>
        );
      },
    },
  ];

  // Jobs Fulfilled columns
  const jobsFulfilledColumns = [
    { 
      title: "Job Id", 
      dataIndex: "id", 
      key: "id",
      width: 130,
      render: (id) => (
        <a
          onClick={() => navigate(`/admin/job-requirments/job-details/${id}`)}
          style={{ color: "#1890ff", cursor: "pointer", fontWeight: 500 }}
        >
          {id}
        </a>
      ),
    },
    { 
      title: "Customer Organization", 
      dataIndex: "customerOrganization", 
      key: "customerOrganization", 
      width: 180,
      render: (org) => org ? (
        <a
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() => navigate(`/admin/organization/${encodeURIComponent(org)}`, {
            state: { from: "/admin/job-requirments", fromLabel: "Back to Job Requirements" }
          })}
        >
          {org}
        </a>
      ) : "-",
    },
    { title: "Job Title", dataIndex: "role", key: "role", width: 180 },
    { title: "Location", dataIndex: "location", key: "location", width: 180, render: (loc) => formatLocation(loc) },
    { title: "Reporting Country", dataIndex: "reportingCountry", key: "reportingCountry", width: 150, render: (v) => v || "-" },
    { title: "Type", dataIndex: "engagement_type", key: "engagement_type", width: 140 },
    { title: "Positions", dataIndex: "requirement_count", key: "requirement_count", width: 100 },
    { 
      title: "Talents Hired", 
      dataIndex: "hired_count", 
      key: "hired_count",
      width: 120,
      render: (count) => (
        <Tag color="green" icon={<CheckCircleOutlined />}>
          {count || 0} Hired
        </Tag>
      ),
    },
    { title: "Budget", dataIndex: "budget", key: "budget", width: 130 },
    { title: "Start Date", dataIndex: "start_date", key: "start_date", width: 120 },
    {
      title: "Action",
      key: "action",
      width: 120,
      fixed: "right",
      render: (_, record) => (
        <Tooltip title="View Hired Talents">
          <Button 
            type="primary" 
            size="small"
            style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            onClick={() => navigate(`/admin/job-requirments/hired-talents/${record.id}`)}
          >
            View Hired
          </Button>
        </Tooltip>
      ),
    },
  ];

  // Get columns based on active tab
  const getColumns = () => {
    if (activeTab === "Jobs Fulfilled") return jobsFulfilledColumns;
    return activeJobsColumns;
  };


  const fetchJobs = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const response = await axios.post(API_CONST.GET_JOB_REQUIREMENTS, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const jobs = response.data.Response || [];
      const transformedData = jobs.map(job => ({
        key: job.id,
        id: job.id,
        customerOrganization: job.customerOrganization || '-',
        role: job.role,
        location: job.reportingLocation,
        engagement_type: job.engagementType,
        requirement_count: job.numberOfRequirements,
        experience: job.experienceRange,
        engagement_months: job.monthsOfEngagement,
        start_date: formatSafeDate(job.tentativeStartDate),
        budget: `₹${Number(job.budget).toLocaleString('en-IN')}`,
        created_on: formatSafeDate(job.createdAt),
        status: job.status,
        type: job.status === 'open' ? 'Active Jobs' : 
              job.status === 'filled' ? 'Jobs Fulfilled' : 
              (job.status === 'draft' || job.status === 'pending_approval') ? 'Pending' : 'Active Jobs',
        name: job.role,
        profiles_submitted: job.profilesSubmitted || 0,
        hired_count: job.hiredCount || 0,
      }));
      
      setUsersData(transformedData);
    } catch (error) {
      console.error("Error fetching jobs:", error);
      message.error("Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const handleDeleteJob = async (jobId) => {
    Modal.confirm({
      title: "Delete Job",
      content: "Are you sure you want to delete this job requirement?",
      okText: "Delete",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const token = localStorage.getItem("authToken");
          await axios.delete(`${API_CONST.DELETE_JOB_REQUIREMENT}/${jobId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          message.success("Job deleted successfully");
          fetchJobs();
        } catch (error) {
          console.error("Error deleting job:", error);
          message.error("Failed to delete job");
        }
      },
    });
  };

  const handleUpdateStatus = async (jobId, newStatus) => {
    try {
      const token = localStorage.getItem("authToken");
      await axios.patch(`${API_CONST.UPDATE_JOB_STATUS}/${jobId}`, { status: newStatus }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success(`Job status updated to ${newStatus}`);
      fetchJobs();
    } catch (error) {
      console.error("Error updating job status:", error);
      message.error("Failed to update job status");
    }
  };

  const handleApproveJob = (jobId) => {
    Modal.confirm({
      title: "Approve Job",
      content: "Are you sure you want to approve this job? It will become active and visible to partners.",
      okText: "Approve",
      okButtonProps: { style: { backgroundColor: "#52c41a", borderColor: "#52c41a" } },
      onOk: () => handleUpdateStatus(jobId, 'open'),
    });
  };

  const handleRejectJob = (jobId) => {
    Modal.confirm({
      title: "Reject Job",
      content: "Are you sure you want to reject this job? It will be closed and the customer will be notified.",
      okText: "Reject",
      okButtonProps: { danger: true },
      onOk: () => handleUpdateStatus(jobId, 'closed'),
    });
  };

  // Filter data based on active tab
  const getFilteredData = () => {
    return usersData
      .filter((user) => user.type === activeTab)
      .filter((user) => user.name?.toLowerCase().includes(searchText.toLowerCase()));
  };

  const filteredData = getFilteredData();

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => {
    setIsModalVisible(false);
    form.resetFields();
    setSelectedRole(null); // Reset role on modal close
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const activeJobsCount = usersData.filter((user) => user.type === "Active Jobs").length;
  const pendingApprovalCount = usersData.filter((user) => user.type === "Pending Approval").length;
  const profilesSubmittedCount = usersData.reduce((sum, job) => sum + (job.profiles_submitted || 0), 0);
  const jobsFulfilledCount = usersData.filter((user) => user.type === "Jobs Fulfilled").length;

  return (
    <UserManagementWrapper>
      <PageHeader><h1>Job Requirements</h1><p>Post and manage job requirements</p></PageHeader>
      
      <MetricsContainer>
        <Card className="metric-card">
          <div className="metric-content">
            <Avatar
              size={64}
              icon={<ShoppingOutlined />}
              className="metric-icon"
              style={{ backgroundColor: "#e6f7ff" }}
            />
            <div className="metric-info">
              <h3>{activeJobsCount}</h3>
              <p>Active Jobs</p>
            </div>
          </div>
        </Card>
        <Card className="metric-card">
          <div className="metric-content">
            <Avatar
              size={64}
              icon={<WechatOutlined />}
              className="metric-icon"
              style={{ backgroundColor: "#fff7e6" }}
            />
            <div className="metric-info">
              <h3>{profilesSubmittedCount}</h3>
              <p>Profiles Submitted</p>
            </div>
          </div>
        </Card>
        <Card className="metric-card">
          <div className="metric-content">
            <Avatar
              size={64}
              icon={<CheckCircleOutlined />}
              className="metric-icon"
              style={{ backgroundColor: "#f6ffed" }}
            />
            <div className="metric-info">
              <h3>{jobsFulfilledCount}</h3>
              <p>Jobs Fulfilled</p>
            </div>
          </div>
        </Card>
      </MetricsContainer>

      <Flex align="center" justify="space-between" style={{ marginBottom: 16 }}>
        <TabsContainer style={{ margin: 0 }}>
          {["Active Jobs", "Jobs Fulfilled"].map((tab) => (
            <Button
              key={tab}
              className={activeTab === tab ? "tab-button active" : "tab-button"}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </Button>
          ))}
        </TabsContainer>
        <div style={{ display: "flex", gap: 12 }}>
          <Button
            icon={<UploadOutlined />}
            onClick={() => setBulkUploadVisible(true)}
            style={{ height: "40px", fontSize: "14px", fontWeight: 500 }}
          >
            Bulk Upload
          </Button>
          <Link to="/admin/job-requirments/new-job-post">
            <Button 
              type="primary"
              icon={<PlusOutlined />}
              style={{ 
                backgroundColor: "#00d9a9",
                borderColor: "#00d9a9",
                height: "40px",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Add New Job
            </Button>
          </Link>
        </div>
      </Flex>

      <BulkUploadJobs
        visible={bulkUploadVisible}
        onClose={() => setBulkUploadVisible(false)}
        userRole="Admin"
        onUploadComplete={fetchJobs}
      />

      <Flex align="start" justify="space-between">
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search resources using Name"
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: "20px", width: "300px" }}
        />
      </Flex>
      <Table
        loading={loading}
        rowSelection={{ type: "checkbox", ...rowSelection }}
        columns={getColumns()}
        dataSource={filteredData}
        pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "20", "50", "100"], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} rows` }}
        scroll={{ x: 1800 }}
        locale={{ emptyText: "No data found" }}
      />
    </UserManagementWrapper>
  );
};

export default JobRequirments;
